import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';

interface MeResponse {
  admin: { uuid: string; username: string } | null;
}

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const [state, setState] = useState<'loading' | 'authed' | 'unauthed'>('loading');

  useEffect(() => {
    api
      .get<MeResponse>('/api/admin/auth/me')
      .then((data) => setState(data.admin ? 'authed' : 'unauthed'))
      .catch((err) => {
        if (err instanceof ApiError && err.status === 401) setState('unauthed');
        else {
          console.error(err);
          setState('unauthed');
        }
      });
  }, []);

  if (state === 'loading') {
    return (
      <div style={{ padding: 48, textAlign: 'center', color: '#888' }}>Loading…</div>
    );
  }
  if (state === 'unauthed') return <Navigate to="/login" replace />;
  return <>{children}</>;
}
